import { render, staticRenderFns } from "./CourseSignUpForm.vue?vue&type=template&id=1804ceac&scoped=true"
import script from "./CourseSignUpForm.vue?vue&type=script&lang=ts"
export * from "./CourseSignUpForm.vue?vue&type=script&lang=ts"
import style0 from "./CourseSignUpForm.vue?vue&type=style&index=0&id=1804ceac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804ceac",
  null
  
)

export default component.exports